module.exports = __webpack_public_path__ + "static/menny-0ec4155d6cab77a4608b1b6a1e076855.png";